import React from "react";
import { Progress, Space, Typography } from "antd";
import { UserSkillRecord } from "../firebase-config";
import { getSkillDisplayName, skillExpToPercent } from "../utils/skillUtils";
import { getSkillIcon } from "../utils/skillIcons";

interface StatsProps {
  skills: UserSkillRecord[];
}

const Stats: React.FC<StatsProps> = ({ skills }) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={14}>
      {skills.map((skill, index) => {
        const { color, icon } = getSkillIcon(skill.Materia);
        return (
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "44px 1fr 140px",
              alignItems: "center",
              gap: 14,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: color,
                boxShadow: "0 0 0 2px rgba(255,255,255,.18) inset",
                fontSize: 18,
                color: "#fff",
              }}
            >
              {icon}
            </div>

            <div style={{ position: "relative" }}>
              <Progress
                percent={skillExpToPercent(skill.Progress)}
                showInfo={false}
                strokeColor="#53d07c"
                trailColor="rgba(0,0,0,.25)"
                strokeWidth={22}
              />
              <Typography.Text
                style={{
                  color: "#2d1b69",
                  fontWeight: 700,
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textShadow: "0 1px 0 rgba(0,0,0,.3)",
                }}
              >
                {skillExpToPercent(skill.Progress)}%
              </Typography.Text>
            </div>

            <Typography.Text
              style={{
                color: "#2d1b69",
                fontWeight: 700,
                textAlign: "right",
                textShadow: "0 1px 0 rgba(0,0,0,.3)",
              }}
            >
              {getSkillDisplayName(skill.Materia)}
            </Typography.Text>
          </div>
        );
      })}
    </Space>
  );
};

export default Stats;
